import React from 'react';
import { MessageCircle } from 'lucide-react';
import { WA_URL } from '../lib/utils';

const WhatsAppFloat = () => {
  return (
    <a
      href={WA_URL()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco no WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-2xl flex items-center justify-center transition-transform hover:scale-110"
    >
      <MessageCircle className="w-6 h-6 text-white" />
      <span className="absolute top-0 right-0 w-3.5 h-3.5 bg-red-500 rounded-full border-2 border-white pulse-dot" />
    </a>
  );
};

export default WhatsAppFloat;
